import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HubService } from 'src/app/bar/services/hub.service';
import { cardEmptyStateContent, DraftEmptyStateContent, wikiEmptyStateContent } from '../../views/collections-page/helpers/wiki.content';

export type EmptyStateType = 'card' | 'draft' | 'wiki';

export interface EmptyStateModel {
  type: string;
  titleLine: string;
  subtitleLine: string;
  iconSvg: {
    lightUrl: string;
    darkUrl?: string;
  };
  btnText?: string;
  learnMoreLink?: string;
}

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent implements OnInit {
  @Input() type: EmptyStateType;
  @Input() createNewOption: boolean;

  @Output() onCreated = new EventEmitter<string>();

  optionsEmptyState: EmptyStateModel[];

  constructor(private hubService: HubService) {}

  ngOnInit(): void {
    this.hubService.readOnly = true;
    this.hubService.preventSearch = true;
    switch (this.type) {
      case 'card':
        this.optionsEmptyState = cardEmptyStateContent;
        break;
      case 'wiki':
        this.optionsEmptyState = wikiEmptyStateContent;
        break;
      case 'draft':
        this.optionsEmptyState = DraftEmptyStateContent;
        break;
    }
  }

  async createNew(type: string) {
    if (!this.createNewOption) {
      return;
    }
    this.onCreated.emit(type);
  }

  openLearnMore(link: string) {
    window.open(link);
  }
}
